import React, { CSSProperties, useCallback } from 'react';
import styles from "./index.module.scss";

import iHeart from "@/modules/tm/assets/transfer/icon-heart.png";
import iMoney from "@/modules/tm/assets/transfer/icon-money.png";

export interface ITMSearchTopInfoProps {
  style?: CSSProperties;
}

const TMSearchTopInfo: React.FC<ITMSearchTopInfoProps> = (props) => {

  // TODO:
  //const fakeData = useGetDynamicData().data;

  // 单个信息Item
  let createInfo = useCallback(
    (icon: string, title: string, value: string) => {
      return <div className={`${styles.infoItem} flex-row flex-cross-axis-center`}>
        <img className={styles.icon} src={icon} alt="" />
        <span className={styles.title}>{title}</span>
        <span className={styles.value}>{value}</span>
        <div className={styles.arrow}/>
      </div>
    },
    [],
  )

  // 左侧信息
  let infos = (
    <div className="flex-row">
      {/* {createInfo(iHeart, '客户满意度', fakeData ? fakeData.tmTransfer.customerSatisfaction : '-')}
      {createInfo(iMoney, '本月成交', fakeData ? fakeData.tmTransfer.monthTransaction : '-')}
      {createInfo(iMoney, '环比上涨', fakeData ? fakeData.tmTransfer.monthlyIncreases: '-')} */}
    </div>
  );

  return (
    <div style={props.style} className={`${styles.container} flex-row flex-main-axis-between`}>
      {infos}
    </div>
  )
}

export default TMSearchTopInfo;
